import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomFormatInkHighlighter = createSvgIcon(
  <path d="M4.798 22q-.742 0-1.27-.534A1.76 1.76 0 0 1 3 20.182q0-.75.528-1.284a1.72 1.72 0 0 1 1.27-.534H19.18q.74 0 1.27.534.527.534.527 1.284c0 .75-.175.928-.528 1.284a1.72 1.72 0 0 1-1.27.534zm9.528-10.91-2.337-2.363-3.596 3.637 2.315 2.363 3.618-3.636ZM13.27 7.456l2.314 2.34 3.596-3.613-2.337-2.364zm-1.888-.66 4.854 4.91-4.247 4.318q-.54.545-1.27.545c-.73 0-.91-.182-1.27-.545l-.112.09a2 2 0 0 1-.54.319 1.7 1.7 0 0 1-.606.114H5.449q-.314 0-.438-.273-.123-.273.101-.5l2.068-2.069a1.87 1.87 0 0 1-.562-1.306 1.72 1.72 0 0 1 .517-1.307zm0 0 4.202-4.25q.54-.545 1.27-.545c.73 0 .91.182 1.27.545l2.337 2.341q.54.546.539 1.284 0 .739-.54 1.285l-4.224 4.25z" />,
  'CustomFormatInkHighlighter',
);

export default CustomFormatInkHighlighter;
